import React, { useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"

function PublishTimestamp() {
  const data = useStaticQuery(graphql`
    query {
      currentBuildDate {
        currentDate
      }
    }
  `)

  const buildTimestamp = data?.currentBuildDate?.currentDate

  useEffect(() => {
    if (buildTimestamp) {
      const formattedTimestamp = new Date(buildTimestamp).toLocaleString()
      console.log("Website build timestamp: ", formattedTimestamp)
    }
  }, [buildTimestamp])

  return null
}

export default PublishTimestamp
